import React from 'react';
import SEO from '../components/SEO';
import './LegalPage.css';

const PrivacyPage = () => (
  <div className="legal-page">
    <SEO title="Gizlilik Politikası" path="/gizlilik" />
    <div className="legal-page__container">
      <h1>Gizlilik Politikası</h1>
      <p className="legal-page__date">Son güncelleme: 26 Temmuz 2026</p>

      <p>isBulsun.com olarak kişisel verilerinizin korunmasına büyük önem veriyoruz. Bu gizlilik politikası, platformumuz aracılığıyla toplanan, işlenen ve saklanan kişisel verilere ilişkin uygulamalarımızı açıklar.</p>

      <h2>1. Toplanan Veriler</h2>
      <p>Platformumuzu kullandığınızda aşağıdaki kişisel verileri toplayabiliriz:</p>
      <ul>
        <li><strong>Kimlik bilgileri:</strong> Ad, soyad, doğum tarihi, uyruk</li>
        <li><strong>İletişim bilgileri:</strong> E-posta adresi, telefon numarası, yaşadığınız şehir ve ülke</li>
        <li><strong>Özgeçmiş (CV) bilgileri:</strong> İş deneyimleri, eğitim geçmişi, beceriler, sertifikalar, dil bilgisi, mesleki yeterlilik belgeleri, sürücü belgesi bilgileri</li>
        <li><strong>Kariyer profili bilgileri:</strong> Kariyer hedefleri, çalışma tercihleri, meslek motivasyonu, yurt dışı çalışma ilgisi</li>
        <li><strong>Göç ve vize bilgileri:</strong> Vize geçmişi, göç planları, hedef ülke tercihleri (yalnızca yurt dışı modülünü kullanan adaylar için)</li>
        <li><strong>Yüklenen belgeler:</strong> CV dosyaları (PDF, DOC, DOCX)</li>
        <li><strong>Hesap bilgileri:</strong> Google, Facebook, LinkedIn veya e-posta ile giriş bilgileri</li>
      </ul>

      <h2>2. Verilerin Kullanım Amaçları</h2>
      <p>Toplanan kişisel verileriniz aşağıdaki amaçlarla işlenir:</p>
      <ul>
        <li>CV ve özgeçmiş oluşturma, düzenleme ve saklama</li>
        <li>Yapay zeka ile iş ilanı eşleştirme ve uygunluk analizi</li>
        <li>CV analizi ve ATS uyumluluk değerlendirmesi</li>
        <li>Otomatik ve manuel iş başvurusu yapma</li>
        <li>Kariyer profili ve yetkinlik raporu oluşturma</li>
        <li>Yurt dışı çalışma rehberliği ve vize uygunluk değerlendirmesi</li>
        <li>Mülakat pratiği ve kariyer gelişim önerileri sunma</li>
        <li>Platform güvenliğinin sağlanması ve hizmet kalitesinin artırılması</li>
      </ul>

      <h2>3. Yapay Zeka ile Veri İşleme</h2>
      <p>isBulsun.com, yapay zeka teknolojilerini aşağıdaki süreçlerde kullanır:</p>
      <ul>
        <li>CV'nizin içeriğini analiz ederek size uygun iş ilanlarını eşleştirme</li>
        <li>CV'nizi iş ilanı gereksinimlerine göre optimize etme önerileri sunma</li>
        <li>Yetkinlik ve kariyer seviyenizi değerlendirme</li>
        <li>Yüklenen CV dosyalarını otomatik olarak ayrıştırma ve yapılandırma</li>
      </ul>
      <p>Yapay zeka tarafından üretilen değerlendirmeler öneri niteliğindedir ve nihai karar her zaman size aittir.</p>

      <h2>4. Verilerin Paylaşımı</h2>
      <p>Kişisel verileriniz aşağıdaki durumlar dışında üçüncü taraflarla paylaşılmaz:</p>
      <ul>
        <li>Sizin açık onayınızla iş başvurusu yapılan işverenlere</li>
        <li>Yasal zorunluluklar gereği yetkili kurum ve kuruluşlara</li>
        <li>Hizmet sağlayıcılarımıza (sunucu, altyapı), yalnızca hizmetin ifası için gerekli olduğu ölçüde</li>
      </ul>
      <p>Verileriniz hiçbir koşulda reklam veya pazarlama amacıyla üçüncü taraflara satılmaz.</p>

      <h2>5. Verilerin Saklanması ve Güvenliği</h2>
      <p>Verileriniz, endüstri standartlarında güvenlik önlemleriyle korunan sunucularda saklanır. SSL/TLS şifreleme, erişim kontrolü ve düzenli güvenlik denetimleri uygulanır.</p>

      <h2>6. Haklarınız</h2>
      <p>6698 sayılı Kişisel Verilerin Korunması Kanunu (KVKK) kapsamında aşağıdaki haklara sahipsiniz:</p>
      <ul>
        <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
        <li>İşlenmiş verilere ilişkin bilgi talep etme</li>
        <li>Verilerin düzeltilmesini veya silinmesini isteme</li>
        <li>İşlemenin kısıtlanmasını talep etme</li>
        <li>Verilerinizin taşınmasını isteme</li>
        <li>İşlemeye itiraz etme</li>
      </ul>
      <p>Hesabınızı dilediğiniz zaman silebilir ve tüm verilerinizin kalıcı olarak kaldırılmasını talep edebilirsiniz.</p>

      <h2>7. Çerezler</h2>
      <p>Platformumuz, oturum yönetimi ve kullanıcı deneyimini iyileştirmek amacıyla çerezler kullanır. Tarayıcı ayarlarınızdan çerezleri yönetebilirsiniz.</p>

      <h2>8. İletişim</h2>
      <p>Gizlilik politikamız hakkında sorularınız için bizimle iletişime geçebilirsiniz:</p>
      <p><strong>E-posta:</strong> info@isbulsun.com<br /><strong>Telefon:</strong> 0850 307 80 61</p>

      <p>Bu gizlilik politikası isBulsun.com tarafından güncellenebilir. Güncellemeler bu sayfada yayınlanır.</p>
    </div>
  </div>
);

export default PrivacyPage;
